import React from 'react';
import Section from '../models/Section';
import Dropdown from '../components/Dropdown';
import SectionsList from './SectionsList';

export interface SubnavDropdownProps {
  heading: string;
  sections: Section[];
  searchable?: boolean;
  className?: string;
  sectionsClickable?: boolean;
}

export default class SubnavDropdown extends React.PureComponent<SubnavDropdownProps> {
  render() {
    return (
      <Dropdown
        className={this.props.className}
        heading={this.props.heading}
        menu={
          <SectionsList
            sections={this.props.sections}
            searchable={this.props.searchable}
            sectionsClickable={this.props.sectionsClickable}
          />
        }
      />
    );
  }
}
